<div class="dialog-overlay" *ngIf="isOpen">

    <div class="dialog-container">
        <h2>Add Account Codes to <i>{{currentView}}</i></h2>
        <div class="dialog-actions">
            <button (click)="close()">Cancel</button>
            <button (click)="save()">Save</button>
        </div>
        <hr />

        <div class="row" style="text-align: center;">
            <div class="col-6">
                <h5>Select Account to Add</h5>
                <div>
                    <div class="row" style="text-align: left;">
                        <div class="col-1">
                        </div>
                        <div class="col-2">
                            <b>Account Code</b>
                        </div>
                        <div class="col-2">
                            <b>Parent Account Code</b>
                        </div>
                        <div class="col-5">
                            <b>Name</b>
                        </div>
                    </div>
                </div>
                <div class="dialog-content">
                    <div *ngFor="let a of distinctAccounts">
                        <div class="row" style="text-align: left;"
                            (click)="onAccountSelected(a.accountCode, a.parentAccountCode)"
                            [id]="a.accountCode + '_' + a.parentAccountCode">
                            <div class="col-1">
                            </div>
                            <div class="col-2">
                                {{a.accountCode}}
                            </div>
                            <div class="col-2">
                                {{a.parentAccountCode}}
                            </div>
                            <div class="col-5">
                                {{a.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <h5>Accounts to Add</h5>
                <div>
                    <div class="row" style="text-align: left;">
                        <div class="col-1">
                        </div>
                        <div class="col-2">
                            <b>Account Code</b>
                        </div>
                        <div class="col-2">
                            <b>Parent Account Code</b>
                        </div>
                        <div class="col-5">
                            <b>Name</b>
                        </div>
                    </div>
                </div>
                <div class="dialog-content">
                    <div *ngFor="let a of selectedAccounts">
                        <div class="row" style="text-align: left;">
                            <div class="col-1">
                                <input type="checkbox" [id]="a.accountCode + '_' + a.parentAccountCode + '_selected'"
                                    [(ngModel)]="a.isChecked"
                                    (change)="onSelectedAccountSelected(a.accountCode, a.parentAccountCode)" />
                            </div>
                            <div class="col-2">
                                {{a.accountCode}}
                            </div>
                            <div class="col-2">
                                {{a.parentAccountCode}}
                            </div>
                            <div class="col-5">
                                {{a.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>